"use strict";
/*
 * Copyright (C) 2023 Klaus Reimer <k@ailis.de>
 * See LICENSE.md for licensing information.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlendMode = void 0;
/** Layer blend modes. */
var BlendMode;
(function (BlendMode) {
    BlendMode["Normal"] = "normal";
    BlendMode["Darken"] = "darken";
    BlendMode["Multiply"] = "multiply";
    BlendMode["ColorBurn"] = "color_burn";
    BlendMode["Lighten"] = "lighten";
    BlendMode["Screen"] = "screen";
    BlendMode["ColorDodge"] = "color_dodge";
    BlendMode["Addition"] = "addition";
    BlendMode["Overlay"] = "overlay";
    BlendMode["SoftLight"] = "soft_light";
    BlendMode["HardLight"] = "hard_light";
    BlendMode["Difference"] = "difference";
    BlendMode["Exclusion"] = "exclusion";
    BlendMode["Subtract"] = "subtract";
    BlendMode["Divide"] = "divide";
    BlendMode["Hue"] = "hsl_hue";
    BlendMode["Saturation"] = "hsl_saturation";
    BlendMode["Color"] = "hsl_color";
    BlendMode["Luminosity"] = "hsl_luminosity";
})(BlendMode || (exports.BlendMode = BlendMode = {}));
//# sourceMappingURL=BlendMode.js.map